export default "__VITE_ASSET__BGjM6IJ___"